// extracted by mini-css-extract-plugin
export default {"list":"LanguageSelector_list__BU37R","antlistitem":"LanguageSelector_antlistitem__QgITz"};